import React, { useEffect, useState } from "react";
import PlaceOrdersService from "../services/PlaceOrderService";
import { Button } from "@headlessui/react";
import { NavLink, useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Pagination from "./Pagination";
import DataTable from "react-data-table-component";
function AdminDashBoard() {
  const location = useLocation();
  const getpageid = location.search.split("=")[1]
    ? location.search.split("=")[1]
    : 1;
  const [orders, setOrders] = useState([]);
  const [paginatelinks, setPaginatelinks] = useState([]);
  const [paginatemeta, setPaginatemeta] = useState([]);
  const user = useSelector((state) => state.user.token);
  const navigate = useNavigate();
  useEffect(() => {
    retrieveOrders();
  }, [getpageid]);

  const retrieveOrders = () => {
    PlaceOrdersService.getAll(getpageid)
      .then((response) => {
        // console.log("User Orders:" + JSON.stringify(response.data));
        setOrders(response.data.data);
        setData(response.data.data);
        setPaginatelinks(response.data.links);
        setPaginatemeta(response.data.meta);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // console.log("Page:" + JSON.stringify(getpageid));

  const deleteOrder = (id) => {
    PlaceOrdersService.remove(id)
      .then((response) => {
        console.log("Delete:" + JSON.stringify(response.data));
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // React Data Table
  const columns = [
    {
      name: "Order",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.created_at.split("T")[0],
      sortable: true,
    },

    {
      name: "Payment Method",
      selector: (row) => row.paymentmethod,
      sortable: true,
    },

    {
      name: "Amount",
      selector: (row) => parseInt(row.totalprice),
      sortable: true,
    },
    {
      name: "Paid",
      selector: (row) => (row.ispaid == 1 ? "Paid" : "Unpaid"),
      sortable: true,
    },
    {
      name: "Picked",
      selector: (row) => (row.isdelivered == 1 ? "Picked" : "UnPicked"),
      sortable: true,
    },
  ];

  const [data, setData] = useState([]);

  return (
    <div className="container">
      <div className="text-3xl py-7">Order DashBoard</div>

      <DataTable
        columns={columns}
        data={data}
        direction="auto"
        fixedHeader
        // fixedHeaderScrollHeight="400px"
        // pagination
        responsive
        subHeaderAlign="right"
        subHeaderWrap
      />
    </div>
  );
}

export default AdminDashBoard;
